import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { PatientsService } from "../patients.service";
import { Patient } from "../patients/patient";
import { LoginService } from "../login.service";
import { HttpClient } from "@angular/common/http";
import { TranslateService } from "@ngx-translate/core";
import { baseCountries, israelCountry, Country } from "../patients/country";

@Component({
    selector: "app-patdetails",
    templateUrl: "./patdetails.component.html",
    styleUrls: ["./patdetails.component.scss"],
    standalone: false
})
export class PatdetailsComponent implements OnInit {
  currentPatient: Patient;
  @Input("awl") awl: number;
  @Input("awlTime") awlTime: string;
  @Input("awlExam") awlExam: string;
  @Input("awlLMP") awlLMP: string;
  @Input("awlComment") awlComment: string;
  @Input("openWAWL") open_w_awl: boolean;
  @Output() closed = new EventEmitter<string>();
  @Output() showpay = new EventEmitter<null>();
  @Output() show_surrogate = new EventEmitter<null>();
  @Input("page") page: string;
  warning: string;

  minLMP: Date;
  maxLMP: Date;
  maxBD: Date;
  startBD: Date;
  invalidlmp = "";
  LMP;
  Birth;
  openAWL: boolean;
  prnerr: string = null;
  treatmenterr: string = null;
  PRNVerified = false;
  iderr: string = null;
  idchanged = false;
  hideSave = false;
  ecode: number;
  ecodes: any[];
  ecodeTxt: string[];
  copyTo: number;
  tryCopy = false;
  copyNote: string;
  codesChanged = false;

  examTypes = [
    "1st",
    "NT",
    "Early Anatomy",
    "2nd/3rd Trimester",
    "Late Anatomy",
    "Specialized",
    "Fetal Echo",
    "Pediatric Echo",
    "Weight Assessment",
    "Tech Exam",
    "Gynecology",
    "Follicles",
    "Consultation Visit",
  ];

  cardioTodayListExams = [
    "אקו",
    "אקו לב",
    "אקו מכבי",
    "אקו לאומית",
    "אקו מאוחדת",
    "אקו לב במאמץ",
    "אקו במאמץ מכבי",
    "אקו במאמץ לאומית",
    "אקו במאמץ מאוחדת",
    "אקו במאמץ פרטי",
    "ארגומטריה",
    "ארגומטריה מכבי",
    "ארגומטריה לאומית",
    "ארגומטריה מאוחדת",
    "הולטר קצב לב",
    "בדיקת אקג",
    "קרוטיד US עורקי צואר",
    "ייעוץ קרדיולוגי",
    "יעוץ רפואי מכבי",
    "יעוץ רפואי לאומית",
    "יעוץ רפואי מאוחדת",
    "יעוץ רפואי כללית מושלם",
  ];

  GA;

  public countries: Country[] = [...baseCountries];
  public filteredCountries: Country[] = [];
  public selectedCountryName: string = "";

  constructor(
    public patservice: PatientsService,
    public ls: LoginService,
    private http: HttpClient,
    private translate: TranslateService
  ) {
    this.maxLMP = new Date();
    this.maxLMP.setMonth(this.maxLMP.getMonth() - 1);
    this.minLMP = new Date();
    this.minLMP.setMonth(this.minLMP.getMonth() - 10);
    this.maxBD = new Date();
    this.maxBD.setFullYear(this.maxBD.getFullYear() - 12);
  }

  ngOnInit() {
    this.currentPatient = this.patservice.getPat();
    // Convert country code to display name
    const selected = this.countries.find((c) => c.code === this.currentPatient.country);
    this.selectedCountryName = selected?.name ?? "";

    // Initialize filter
    this.filteredCountries = this.countries;
    this.LMP = this.currentPatient.LMP;
    if (this.awlLMP) {
      this.GA = this.lmpGA(this.awlLMP);
    }
    this.Birth = this.currentPatient.Birth;

    // if(this.myPat.Birth.split(" ").length > 0)
    if (this.currentPatient.Birth && this.currentPatient.Birth != "") {
      this.currentPatient.Birth = this.currentPatient.Birth.split(" ")[0];
      this.startBD = new Date();
      this.startBD.setFullYear(this.startBD.getFullYear() - 22);
    }
    this.clearSpace();
    this.PRNVerified = !this.ls.PRNcheck; //don't check prn if diabled
    if (this.open_w_awl) this.openAWL = true;
    if (this.currentPatient["PaymentCodes"] && this.ls.ExamCodes) {
      //for belinson
      this.ecodes = this.currentPatient["PaymentCodes"].split(",");
      this.ecodeTxt = [];
      for (let code of this.ecodes) {
        for (let ec of this.ls.ExamCodes) {
          if (code == ec[0]) this.ecodeTxt.push(ec[1]);
        }
      }
    }
    this.patservice.getZimunfeedID();

    if (this.currentPatient.IsID === null) {
      this.currentPatient.IsID = 1; // fallback only if not set
    }

    // Add IL only if IsID === 1
    if (this.currentPatient.IsID === 1) {
      this.countries = [...baseCountries, israelCountry];
    } else {
      this.countries = [...baseCountries];
    }

    const current = this.countries.find((c) => c.code === this.currentPatient.country);
    this.selectedCountryName = current?.name ?? "";
  }

  onCountryInputChange(name: string): void {
    this.filteredCountries = this.countries.filter((c) =>
      c.name.toLowerCase().includes(name.toLowerCase())
    );

    // Update selected country code
    const selected = this.countries.find((c) => c.name === name);
    this.currentPatient.country = selected?.code || "";
  }

  onIsIDChange(value: number): void {
    if (value === 1) {
      // Switches to ID mode to select Israel
      this.countries = [...baseCountries, israelCountry];
      this.currentPatient.country = israelCountry.code;
      this.selectedCountryName = israelCountry.name;
    } else {
      // Switches to passport mode to hide Israel
      this.countries = [...baseCountries];

      // Clears Israel if selected
      if (this.currentPatient.country === "IL") {
        this.currentPatient.country = "";
        this.selectedCountryName = "";
      }
    }

    // Refresh filtered list
    this.onCountryInputChange(this.selectedCountryName);
  }

  savePatient(cb = null, noclose = false, openWEB = false) {
    this.hideSave = true;
    if (!this.currentPatient.UID && this.ls.doctor) {
      this.currentPatient.UID = this.ls.doctor;
    }

    this.patservice
      .savePatient(
        this.currentPatient,
        this.currentPatient.PID,
        this.currentPatient.isBusinessClient,
        this.ls.premissions.BusinessClients
      )
      .subscribe(
        (data) => {
          if (data.hasOwnProperty("error")) {
            this.hideSave = false;
            this.warning = data["error"];
            if (cb) cb(data["error"]);
          } else {
            if (data["PID"]) {
              this.patservice.currentPatient.PID = data["PID"];
            }
            this.closed.emit("appointmentDetails");
            if (cb) {
              cb(false);
            }

            if (!this.ls.ishospital && this.patservice.zimunFeedID && openWEB) {
              this.goOldWebPatientPage(this.currentPatient.ID, this.patservice.zimunFeedID)
                .then((url) => {
                  window.open(url, "_blank");
                })
                .catch((error) => {
                  console.log(error);
                });
            }
          }
        }, // success path
        (error) => {
          // error path(data)=>
          this.hideSave = false;
          this.warning = error.error.error;
          if (cb) cb(error);
        }
      );
  }

  dateChanged(itemName: string) {
    try {
      this.currentPatient[itemName] = this[itemName].format("YYYY-MM-DD");
    } catch {}
    //this.myPat['LMP'] = this[itemName].format("YYYY-MM-DD");
    //this.GA = this.lmpGA(this.awlLMP);
  }

  lmpGA(lmp) {
    if (!lmp) return "";
    let dt = new Date();
    let days = Math.floor((dt.getTime() - Date.parse(lmp)) / (1000 * 60 * 60 * 24));
    if (Math.floor(days / 7) < 1 || Math.floor(days / 7) > 50) return "";
    return Math.floor(days / 7) + "w " + (Math.floor(days) % 7) + "d";
  }

  close(openOtherModal = false) {
    this.closed.emit(openOtherModal ? "appointmentDetails" : "");
  }

  closeFromBilling(shouldClose: boolean) {
    this.closed.emit(shouldClose ? "1" : null);
  }

  getBMI() {
    if (!this.currentPatient.Height || !this.currentPatient.Weight) return "";
    return (
      Math.round((10 * this.currentPatient.Weight) / Math.pow(this.currentPatient.Height / 100, 2)) / 10
    );
  }

  getBSA() {
    if (this.currentPatient.BSAus) return this.currentPatient.BSAus;
    if (!this.currentPatient.Height || !this.currentPatient.Weight) return "";
    return (
      Math.round(100 * Math.sqrt((this.currentPatient.Height * this.currentPatient.Weight) / 3600)) /
        100 +
      "m²"
    );
  }

  clearSpace() {
    try {
      this.currentPatient.ID = this.currentPatient.ID.replace(/\s+/, "");
    } catch (e) {}
  }

  saveAWL(cb = null) {
    if (this.idchanged) {
      this.savePatient((err) => {
        if (!err)
          this.patservice
            .saveAWL(
              this.awl,
              this.awlTime,
              this.awlLMP,
              this.awlExam,
              this.awlComment,
              this.currentPatient.PID,
              this.currentPatient.PRN,
              this.currentPatient.Code,
              null,
              this.ls.isAdmin || this.ls.userType == "secretary"
                ? this.currentPatient.UID
                  ? this.currentPatient.UID
                  : this.ls.doctor
                : null
            )
            .subscribe(
              (data) => {
                this.closed.emit("awl");
              },
              (error) => {
                console.log(error);
              }
            );
      }, true);
    } //only save awl
    else
      this.patservice
        .saveAWL(
          this.awl,
          this.awlTime,
          this.awlLMP,
          this.awlExam,
          this.awlComment,
          this.currentPatient.PID,
          this.currentPatient.PRN,
          this.currentPatient.Code,
          this.ecodes,
          this.ls.isAdmin || this.ls.userType == "secretary"
            ? this.currentPatient.UID
              ? this.currentPatient.UID
              : this.ls.doctor
            : null
        )
        .subscribe(
          (data) => {
            this.closed.emit("awl");
          },
          (error) => {
            console.log(error);
          }
        );
  }

  deleteAWL() {
    this.patservice.deleteAWL(this.awl).subscribe(
      (data) => {
        this.closed.emit("awl");
      },
      (err) => {
        console.log(err);
      }
    );
  }

  prepareAWL() {
    if (!this.currentPatient.PID) {
      //save the patient and then open
      this.hideSave = true;
      this.patservice.savePatient(this.currentPatient).subscribe(
        (data) => {
          if (data.hasOwnProperty("error")) {
            this.warning = data["error"];
            this.hideSave = false;
          } else {
            if (data["PID"]) {
              this.currentPatient.PID = data["PID"];
              this.openAWL = true;
            }
          }
        }, // success path
        (error) => {
          // error path(data)=>
          this.warning = error.error.error;
          this.hideSave = false;
        }
      );
    } else this.openAWL = true;
  }

  checklmp() {
    if (this.awlLMP) {
      let dt = new Date(this.awlLMP);
      if (dt < this.minLMP || dt > this.maxLMP) this.invalidlmp = "is-invalid";
      else this.invalidlmp = "";
    }
  }

  checkPRN() {
    if (
      this.currentPatient.Code &&
      this.currentPatient.PRN &&
      this.currentPatient.PRN.length > 8 &&
      this.currentPatient.Code.length > 4
    ) {
      this.patservice
        .checkPRN(this.currentPatient.ID, this.currentPatient.PRN, this.currentPatient.Code)
        .subscribe(
          (data) => {
            if (data["response"] == "") {
              //verified
              this.PRNVerified = true;
              this.prnerr = null;
              this.iderr = null;
            } else {
              this.iderr = null;
              if (data["response"].indexOf("התחייבות לא שייך למבוטח") > -1)
                this.iderr = data["response"];
              this.prnerr = data["response"];
            }
          },
          (err) => {
            this.prnerr = err["error"];
          }
        );
    }
  }

  checkLength() {
    if (!this.ls.PRNcheck) return;
    this.PRNVerified = false;
    if (
      this.currentPatient.PRN &&
      this.currentPatient.PRN.length > 0 &&
      this.currentPatient.PRN.length < 9
    )
      this.prnerr = "PRN invalid";
    else this.prnerr = null;
    if (
      this.currentPatient.Code &&
      this.currentPatient.Code.length > 0 &&
      this.currentPatient.Code.length < 5
    )
      this.treatmenterr = "is-invalid";
    else this.treatmenterr = null;
  }

  IDValidator() {
    if (this.currentPatient.IsID == 0) return true;
    let id: any = this.currentPatient.ID.replace("-", "");
    if (id.length < 9 || isNaN(id)) {
      // Make sure ID is formatted properly
      return false;
    }
    let sum = 0,
      incNum;
    for (let i = 0; i < id.length; i++) {
      incNum = Number(id[i]) * ((i % 2) + 1); // Multiply number by 1 or 2
      sum += incNum > 9 ? incNum - 9 : incNum; // Sum the digits up and add to total
    }
    return sum % 10 === 0;
  }

  receive() {
    //mark as recived in db
    this.patservice.receivePat(this.awl).subscribe(
      (data) => {
        this.closed.next("awl");
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getExamTypes() {
    if (this.ls.isGastro) {
      return ["Colonoscopy", "Gastroscopy", "Gastro-Colonoscopy", "Sigmoidoscopy"];
    }
    if (this.ls.isCardio) return this.cardioTodayListExams;
    if (this.ls.premissions?.thirdScan && !this.examTypes.includes("Third Scan")) {
      this.examTypes.push("Third Scan");
    }
    return this.examTypes;
  }

  addCode() {
    if (!this.ecodes) {
      this.ecodes = [];
      this.ecodeTxt = [];
    }
    if (!this.ecodes.includes(this.ecode)) {
      this.ecodes.push(this.ecode);
      for (let ec of this.ls.ExamCodes) {
        if (this.ecode == ec[0]) this.ecodeTxt.push(ec[1] + "(" + ec[0] + ")");
      }
      this.codesChanged = true;
    }
    setTimeout(() => {
      this.ecode = 0;
    }, 1);
  }

  removeCode(index: number) {
    this.ecodes.splice(index, 1);
    this.ecodeTxt.splice(index, 1);
    this.codesChanged = true;
  }

  copyPat() {
    this.copyNote = null;
    if (!this.copyTo) return;
    this.tryCopy = true;
    this.patservice.copyPat(this.currentPatient.PID, this.copyTo).subscribe(
      (d) => {
        this.copyNote = "Patient copied";
        this.tryCopy = false;
      },
      (error) => {
        this.tryCopy = false;
        this.copyNote = error.error.error;
      }
    );
  }

  // Redirects to the patient's page in old web:
  goOldWebPatientPage(patientID: string, zimunFeedID: number): Promise<string> {
    return new Promise((resolve, reject) => {
      if (!this.ls.ishospital) {
        try {
          this.http.get(`/api/old-web/${patientID}/${zimunFeedID}`).subscribe(
            (data) => {
              const url = `https://artisanmedical.co.il/Patient/viewGeneralPatient.php?PatSysID=${data}`;
              resolve(url);
            },
            (error) => {
              reject(error);
            }
          );
        } catch (error) {
          console.error("Error fetching patient data: ", error);
          reject(error);
        }
      } else {
        reject("Cannot get patSysID.");
      }
    });
  }

  sendATD() {
    // this.myPat.ATDNotify = new Date();
    this.patservice.notifyATD(this.currentPatient.AWLID).subscribe(
      () => {
        this.closed.emit("awl");
      },
      (err) => {
        console.log(err);
        // this.myPat.ATDNotify = null;
      }
    );
  }

  onSexChange() {
    if (this.currentPatient.Sex === "M") {
      this.currentPatient.LMP = null;
    }
  }

  hasAllRequiredFields(): boolean {
    const requiredFields: any[] = [];

    // Require patient details
    if (this.ls?.premissions?.requirePatientDetails && !this.currentPatient?.isBusinessClient) {
      requiredFields.push(this.currentPatient?.FirstEng);
      requiredFields.push(this.currentPatient?.LastEng);
      requiredFields.push(this.Birth);
    }

    // Require HMO + Insurance (only if not a business client)
    if (this.ls?.premissions?.requireHMO && !this.currentPatient?.isBusinessClient) {
      requiredFields.push(this.currentPatient?.HMO);
      requiredFields.push(this.currentPatient?.Insurance);
    }

    // Require country if Billings is on AND patient has no ID
    if (
      this.ls?.premissions?.Billings &&
      this.currentPatient?.IsID === 0 &&
      !this.currentPatient?.country
    ) {
      requiredFields.push(this.currentPatient?.country);
    }

    // Check all collected fields
    return requiredFields.every((field) => field !== undefined && field !== null && field !== "");
  }

  getMissingFieldsTooltip(): string {
    const missingFields: string[] = [];
    if (this.currentPatient?.isBusinessClient) return;
    if (this.ls?.premissions?.requirePatientDetails) {
      if (!this.currentPatient?.FirstEng?.trim()) {
        missingFields.push("First Name (English)");
      }
      if (!this.currentPatient?.LastEng?.trim()) {
        missingFields.push("Last Name (English)");
      }
      if (!this.Birth) {
        missingFields.push("Birth Date");
      }
    }
    if (this.ls?.premissions?.requireHMO && !this.currentPatient?.HMO) {
      missingFields.push("HMO");
    }

    if (this.ls?.premissions?.requireHMO && !this.currentPatient?.Insurance) {
      missingFields.push("Insurance");
    }

    return missingFields.length > 0
      ? this.translate.instant("appointments.gui.tooltips.Please fill in the required fields")
      : this.translate.instant("GUI.Tooltips.Save patients details");
  }

  get isFirstNameMissing(): boolean {
    return this.ls?.premissions?.requirePatientDetails && !this.currentPatient?.FirstEng;
  }

  get isLastNameMissing(): boolean {
    return this.ls?.premissions?.requirePatientDetails && !this.currentPatient?.LastEng;
  }

  get isBirthDateMissing(): boolean {
    return this.ls?.premissions?.requirePatientDetails && !this.Birth;
  }

  get isHMOMissing(): boolean {
    return this.ls?.premissions?.requireHMO && !this.currentPatient.HMO;
  }

  get isInsuranceMissing(): boolean {
    return this.ls?.premissions?.requireHMO && !this.currentPatient.Insurance;
  }

  get isCountryMissing(): boolean {
    return this.currentPatient.IsID === 0 && !this.currentPatient.country;
  }

  get consentYes(): boolean {
    if (!this.currentPatient) return false;
    return this.currentPatient.SmsConsent === true;
  }

  get consentNo(): boolean {
    if (!this.currentPatient) return false;
    return this.currentPatient.SmsConsent === false;
  }

  onConsentYesChange() {
    // Toggle: if currently true, set to null; otherwise set to true
    if (this.currentPatient.SmsConsent === true) {
      this.currentPatient.SmsConsent = null;
    } else {
      this.currentPatient.SmsConsent = true;
    }
  }

  onConsentNoChange() {
    // Toggle: if currently false, set to null; otherwise set to false
    if (this.currentPatient.SmsConsent === false) {
      this.currentPatient.SmsConsent = null;
    } else {
      this.currentPatient.SmsConsent = false;
    }
  }
}
